import { Notyf } from 'notyf';

export const notify = () => {
  return new Notyf({
    duration: 2000,
    position: { x: 'right', y: 'top' },
    types: [
      {
        type: 'error',
        background: '#CB3247',
        duration: 3000,
        dismissible: true
      },
      {
        type: 'success',
        background: '#00813F',
        dismissible: true
      },
    ]
  });
};